module.exports = __webpack_public_path__ + "img/IMG-20171122-WA0035.105d0664.jpg";